import { initializeApp } from '../app.js';
import Container from '../components/Map/Container.vue';
import ProductConfiguratorOverview from '../components/ProductConfigurator/Overview.vue';

initializeApp('#homeapp', {
    'route-map': Container,
    'product-configurator-overview': ProductConfiguratorOverview,
});
